import { Component, h, Prop, Event, EventEmitter } from '@stencil/core';

@Component({
  tag: 'vs-card-2up',
  styleUrl: 'vs-card-2up.scss',
  shadow: false,
})
export class ContentCard2up {
  @Prop() cards: any[] = [];

  @Prop() borderRadius: string;
  @Prop() animation: string;
  @Prop() theme: 'light' | 'dark' = 'light';
  @Prop() imageAspectRatio: string = '1:1';
  @Prop() twoUpAR: string = '3:4';
  @Prop() cardVariant: 'default' | 'product' | 'icon' = 'default';
  @Prop() imageVariant: string = 'variant1';

  @Event() compareClicked: EventEmitter<{ card: any; index: number }>;

  private handleCompare(card, idx) {
    this.compareClicked.emit({ card, index: idx });
  }

  render() {
    if (!this.cards || this.cards.length < 2) {
      return <div>No cards provided for 2up layout</div>;
    }

    return (
      <div class="vs-content-card__2up-container" role="grid">
        <div class="vs-content-card__2up-wrapper">
          {/* First Card */}
          <div class="vs-content-card__2up-first-card" role="gridcell">
            <vsr-card
              type={this.cards[0].type}
              image-url={this.cards[0].imageUrl}
              borderRadius={this.borderRadius}
              animation={this.animation}
              imageVariant="2up-first"
              imageAspectRatio={this.imageAspectRatio}
              cardVariant={this.cardVariant}
              cardLink={this.cards[0].cardLink}
              cardLinkTarget={this.cards[0].cardLinkTarget}
              imageAltText={this.cards[0].imageAltText}
              title={this.cards[0].title}
              description={this.cards[0].description}
              cardCta={this.cards[0].cardCta}
              button-text-2={this.cards[0].buttonText2}
              key={`${this.cards[0].title}+0`}
              onCompareClicked={() => this.handleCompare(this.cards[0], 0)}
              theme={this.theme}
              media-src={this.cards[0].videoUrl}
              poster={this.cards[0].imageUrl}
              media-type={
                this.cards[0].mediaType == 'image'
                  ? 'image'
                  : this.cards[0].mediaType == 'ambient-video-static'
                    ? 'single'
                    : 'loop'
              }
              video-alt={this.cards[0].imageAltText}
            ></vsr-card>
          </div>

          {/* Second Card */}
          <div class="vs-content-card__2up-second-card" role="gridcell">
            <vsr-card
              type={this.cards[1].type}
              image-url={this.cards[1].imageUrl}
              borderRadius={this.borderRadius}
              animation={this.animation}
              imageVariant="2up-second"
              imageAspectRatio={this.twoUpAR}
              cardVariant={this.cardVariant}
              cardLink={this.cards[1].cardLink}
              cardLinkTarget={this.cards[1].cardLinkTarget}
              imageAltText={this.cards[1].imageAltText}
              title={this.cards[1].title}
              description={this.cards[1].description}
              cardCta={this.cards[1].cardCta}
              button-text-2={this.cards[1].buttonText2}
              key={`${this.cards[1].title}+1`}
              onCompareClicked={() => this.handleCompare(this.cards[1], 1)}
              theme={this.theme}
              media-src={this.cards[1].videoUrl}
              poster={this.cards[1].imageUrl}
              media-type={
                this.cards[1].mediaType == 'image'
                  ? 'image'
                  : this.cards[1].mediaType == 'ambient-video-static'
                    ? 'single'
                    : 'loop'
              }
              video-alt={this.cards[1].imageAltText}
            ></vsr-card>
          </div>
        </div>
      </div>
    );
  }
}
